/**
 * Starts a new Collabo OIDC flow by navigating to the portal start endpoint.
 *
 * window.location is used instead of next/navigation router because the target
 * URL is served by the API (forwarded by the web host) — a soft navigation would
 * stay inside the Next.js app and never reach the backend.
 */
export const redirectToCollaboOidcStart = (
  options: { resumeChallenge?: boolean } = {},
): void => {
  // resume=true tells the callback this tab was mid-challenge for one medimo account, so a
  // Collabo ID linked in the meantime is reported as a conflict instead of signing in as the
  // account that took it.
  const query = options.resumeChallenge === true ? "?resume=true" : "";
  window.location.replace(`/v3/collabo/portal/start${query}`);
};
